module.exports = __webpack_public_path__ + "assets/img/RewardBodyBtn1.1b36690c.png";